// globalStyle.ts
import {createGlobalStyle} from 'styled-components';

const GlobalStyle = createGlobalStyle`
    /* ✅ 나눔바른고딕 로컬 폰트 */
    @font-face {
        font-family: 'Nanum Barun Gothic';
        src: url('/font/NanumBarunGothicUltraLight.woff2') format('woff2');
        font-weight: 200;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Nanum Barun Gothic';
        src: url('/font/NanumBarunGothicLight.woff2') format('woff2');
        font-weight: 300;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Nanum Barun Gothic';
        src: url('/font/NanumBarunGothic.woff2') format('woff2');
        font-weight: 400;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Nanum Barun Gothic';
        src: url('/font/NanumBarunGothicBold.woff2') format('woff2');
        font-weight: 700;
        font-style: normal;
        font-display: swap;
    }

    /* 기본 리셋 및 전역 스타일   */
    * {
        margin: 0;
        padding: 0;
        border: 0;
        font-family: ${({theme}) => theme.fontFamily};
        box-sizing: border-box;
    }

    body {
        background-color: #F0F1F4;
    }

    body,
    th,
    td,
    input,
    select,
    textarea,
    div {
        font-size: 12px;
    }

    img {
        border: 0 none;
        max-width: 100%;
        height: auto;
    }

    button {
        font-size: 12px;
        line-height: 1.4;
        font-family: ${({theme}) => theme.fontFamily};
        color: #181818;
    }
`;

export default GlobalStyle;